// eslint-disable-next-line import/prefer-default-export
export const sortOrderEnums = {
  ASC: 'asc',
  DESC: 'desc',
};

export const sortOrders = [sortOrderEnums.DESC, sortOrderEnums.ASC];
